/**
 * Checks the scale entered is valid for the print layer selected.
 */
    function acceptPrintScale(layer) {
        let acceptable = {};

        switch(layer){
            case "os250k":
                acceptable.min = 60000;
                acceptable.max = 999999999999;
            break;
            case "os50k":
                acceptable.min = 20000;
                acceptable.max = 100000;
            break;
            case "os25k":
                acceptable.min = 8000;
                acceptable.max = 30000;
            break;
            case "os10k":
                acceptable.min = 3500;
                acceptable.max = 15000;
            break;
            case "aerial":
                acceptable.min = 100;
                acceptable.max = 15000;
            break;
            case "osmmbw":
            case "osmm":
            default:
                acceptable.min = 100;
                acceptable.max = 6000;
            break;
        }

        return acceptable;
    }
    
      export default acceptPrintScale;